module.exports = __webpack_public_path__ + "static/img/menu2-img4.2e07a145.png";